import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class BlogService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getBlog(blogId: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/blog/get_one/${blogId}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private blogs: Observable<any> = this.http.get(`${this.apiUrl}/blog`)
    .pipe(
      map((data: any) => data.data),
      publishReplay(1),
      refCount());

  getAllBlog(size = 10, page = 0): Observable<any> {
    let params = new HttpParams();
    params = params.append('size', size.toString());
    params = params.append('page', page.toString());
    return this.http.get(`${this.apiUrl}/blog`, {params})
      .pipe(
        map((response: any) => {
          return response.data;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }
}
